module.exports = __webpack_public_path__ + "static/media/star-christmas.6b711405.svg";